import { SpacerProps } from "./spacer.props";

export const Spacer = ({ size, direction, children = null }: SpacerProps) => {
  return (
    <div
      style={{
        [`margin${
          direction[0].toUpperCase() + direction.slice(1)
        }`]: `${size}px`,
      }}
    >
      {children}
    </div>
  );
};
